export default __webpack_public_path__ + "static/media/january.a9c0f7a6.jpg";